export const TipoCategoriaRelato = {
  PROBLEMA_ERRO_CONTEUDO_VIDEO_AULA: { id: 1, nome: 'Quero falar sobre problemas ou erros de conteúdo da videoaula.' },
  PROBLEMA_PLAYER_VIDEO: { id: 2, nome: 'Quero falar sobre um problema com o player de vídeo.' },
  PROBLEMA_FORA_VIDEO_AULA: { id: 3, nome: 'Quero falar sobre um problema fora da videoaula (ex: um resumo, a área do meu caderno etc).' },
  NENHUMA_CATEGORIA: { id: 4, nome: 'Nenhuma dessas categorias se aproxima do meu problema.' }
}

export const TipoCategoriaRelatoUtil = {

  listar: () => Object.keys(TipoCategoriaRelato).map(key => TipoCategoriaRelato[key])

}

export default TipoCategoriaRelato
